// import styles from '@components/buttons/BackButton.module.css';
import { useHistory } from "react-router";

import TertiaryButton from "@components/buttons/TertiaryButton";

type Props = {
  className?: string;
  routerLink?: string;
};

const BackButton = ({ className = "", routerLink }: Props) => {
  const history = useHistory();

  return (
    <div className={className}>
      <TertiaryButton
        icon="circleArrowLeft"
        onClick={routerLink ? undefined : history.goBack}
        routerLink={routerLink}
        textKey="dictionary.back"
      />
    </div>
  );
};

export default BackButton;
